// custom typefaces
import "typeface-varela-round"

// Prism styling
require("prism-themes/themes/prism-shades-of-purple.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("prismjs/plugins/command-line/prism-command-line.css")
